import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { getFirestore, doc, setDoc, getDoc, query, where, getDocs, updateDoc, collection, documentId } from "firebase/firestore";
import { db } from "../firebase";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { Randomcode } from '../components/rendom_code';
import { LiaPhotoVideoSolid } from "react-icons/lia";
import Loadingimg from "../components/loadingimg";

import './create-job.css';
import Photosicon from '../assets/photos_icon.png';
import Cookies from 'js-cookie';
import { RiSlideshowLine, RiSlideshowFill } from "react-icons/ri";
import { useToast } from '../components/ToastContext';
import { Savejobpost } from '../Save_jobpost';
import Thumbnailicon from '../assets/Thumbnailicon.png';
import { FaLink } from "react-icons/fa6";
import { MdOutlineVisibility } from "react-icons/md";
import { MdPublic } from 'react-icons/md';
import Loading from '../components/loading';
import PhoneCodeList from '../components/PhoneCodeList';
import Statusbar from '../master_root/statusbar';
export default function Createjob() {

  //
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [photoURL, setPhotoURL] = useState("");
  const { showToast } = useToast();
  const [category, setPostcategory] = useState("Job-Task");
  const [Skillscategories, setSkillscategories] = useState([]);
  //const [selectedSkill, setSelectedSkill] = useState("0");
  //const [selectedjobcategories, setSelectedjobcategories] = useState("0");
  const [selectedCode, setSelectedCode] = useState(null);
  const [countryname, setSelectedcountryname] = useState(null);
  const [jobcategories, setJobcategories] = useState([]);
  const [guid, setguid] = useState('');
  const [companyuid, setcompanyuid] = useState('');
  const [newpost, setnewpost] = useState(false);
  const [loading, setLoading] = useState(false);
  const [userlogin, setuserlogin] = useState(false);
  const [experience, setexperience] = useState("Beginner");
  const [budget, setbudget] = useState(0);
  const [budgetpackage, setbudgetpackage] = useState("Monthly");
  const [jobcity, setjobcity] = useState(0);
  const [jobstate, setjobstate] = useState(0);
  const [currency, setcurrency] = useState("INR");
  const [visibility, setvisibility] = useState(false);
  useEffect(() => {
    const existingUser = Cookies.get("guid");
    if (existingUser) {
      setguid(existingUser);
      setuserlogin(true);
    } else {
      navigate('/');
      setuserlogin(false);
    }
  }, []);
  //
  useEffect(() => {
    const fetchSkillscategoriesData = async () => {
      try {
        const q = query(collection(db, "skills_categories"),
          where("status", "==", true)
        );
        const skillSnap = await getDocs(q);
        const skillDocList = skillSnap.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setLoading(false);
        setSkillscategories(skillDocList);
      } catch (error) {
        console.error("Error fetching skill categories:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSkillscategoriesData();
  }, [guid]); // or [] if you want it to run once
  //

  const formatCount = (num) => {
    if (num >= 1e6) return (num / 1e6).toFixed(1).replace(/\.0$/, '') + "M";
    if (num >= 1e3) return (num / 1e3).toFixed(1).replace(/\.0$/, '') + "K";
    return num.toString();
  };

  //
  useEffect(() => {

    const uidParam = searchParams.get("uid");
    setcompanyuid(uidParam);
    setnewpost(true);
    setPhotoURL(Cookies.get('login-photoURL'));
  }, [searchParams]);
  const handlecountryChange = (selectedOption) => {
    setSelectedCode(selectedOption.value.replace("+", ""));
    const countryName = selectedOption.label.split(" (")[0];
    setSelectedcountryname(countryName);
    console.log("Selected Code:", selectedOption.value);
  };
  const [keywords, setKeywords] = useState([]);
  const [input, setInput] = useState('');
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && input.trim() !== '' && keywords.length < 10) {
      e.preventDefault();
      const trimmed = input.trim();
      if (!keywords.includes(trimmed)) {
        setKeywords([...keywords, trimmed]);
      }
      setInput('');
    }
  };

  const removeKeyword = (index) => {
    setKeywords(keywords.filter((_, i) => i !== index));
  };
  const [TitleInput, setTitleInput] = useState("");
  const [DescriptionInput, setDescriptionInput] = useState("");

  const editor_Publish_btn = async () => {

    if (!guid || guid === "0") return;
    // 
    const skillsselect = document.getElementById('skills_select');
    const skillsselectedOption = skillsselect.options[skillsselect.selectedIndex]; // ✅ FIXED: use 'skillsselect'
    const jobcategories_select = document.getElementById('jobcategories_select'); // ✅ Renamed from 'select'
    const jobcategories_selectedOption = jobcategories_select.options[jobcategories_select.selectedIndex]; // ✅ FIXED
    if (!TitleInput) {
      setLoading(false);
      showToast("Enter Title");
      return;
    }
    if (!DescriptionInput) {
      setLoading(false);
      showToast("Enter Description");
      return;
    }
    if (!budget) {
      setLoading(false);
      showToast("Enter budget");
      return;
    }
    if (skillsselectedOption.title === "Select skills") {
      setLoading(false);
      showToast("Enter skills");
      return;
    }
    if (jobcategories_selectedOption.title === "Select job categories") {
      setLoading(false);
      showToast("Enter jobcategories");
      return;
    }
    setLoading(true);
    const keywords = "";//" keywords.join(", ");
    let slug = jobcategories_selectedOption.title + "-" + TitleInput;
    slug = slug.replace(/[^a-zA-Z0-9 ]/g, '').replace(/\s+/g, '-').toLowerCase() + '-' + Randomcode(2);
    const result = await Savejobpost({
      uid: Randomcode(13),
      companysuid: companyuid,
      title: TitleInput,
      description: DescriptionInput,
      budget,
      budgetpackage,
      category,
      accepted: false,
      skillsId: skillsselectedOption.value,
      skills: skillsselectedOption.title,
      jobcategoryId: jobcategories_selectedOption.value,
      jobcategories: jobcategories_selectedOption.title,
      experience,
      slug: slug,
      city: jobcity,
      state: jobstate,
      country: countryname,
      countrycode: selectedCode,
      currency,
      visibility: visibility,
      keywords: keywords,
    });
    if (result.success) {
      showToast('Successfully')
      setTimeout(() => {
        setLoading(false);
        //setKeywords([]);
      }, 1000);
    } else {
      setLoading(false);
      showToast("Failed to publish post");
    }
  };



  const changeskills = (skillsId) => {

    fetchjobcategory(skillsId);
    // fetchJobtasks("0");

  };

  const fetchjobcategory = async (skillsId) => {
    try {

      const q = query(collection(db, "jobcategories"),
        where("skillsId", "==", skillsId),
        where("status", "==", true)
      );
      const jobcategoriesSnap = await getDocs(q);

      const jobcategoriesDocList = jobcategoriesSnap.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setLoading(false);
      setJobcategories(jobcategoriesDocList);

    } catch (error) {
      console.error("Error fetching skill categories:", error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
    <Statusbar data={'Create Job'} />
     <div className='app_header_height'></div>
    <div className="container_roots">
      <div className="container_size">
        <div className="post-container">
          <div className="post_div">
            {/* <b className='post-header'>Create new</b> */}
            <table width="100%">
              <tbody>
                <td>
                  <div className="radio_group_horizontal">
                    <label className="radio_option">
                      <input
                        type="radio"
                        name="category"
                        value="Job-Task"
                        checked={category === "Job-Task"}
                        onChange={(e) => setPostcategory(e.target.value)}
                      />
                      <span className="custom_radio"></span>
                      Job-Task
                    </label>

                    <label className="radio_option">
                      <input
                        type="radio"
                        name="category"
                        value="Project-Task"
                        checked={category === "Project-Task"}
                        onChange={(e) => setPostcategory(e.target.value)}
                      />
                      <span className="custom_radio"></span>
                      Project-Task
                    </label>
                  </div>
                </td>
                <tr>
                  <td >
                    <div className='title-div'>
                      <div className='info_text'>Title </div>
                      {
                        TitleInput.length < 50 ? (
                          <div className='help_text'>Limit {50 - TitleInput.length}</div>
                        ) : (
                          <div className='help_text blink_text_red' >Limit over {50 - TitleInput.length}</div>
                        )
                      }
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <input className='input_edit' onChange={(e) => setTitleInput(e.target.value)} required maxLength={100} placeholder='Enter Title' />
                  </td>
                </tr>
                <tr>
                  <td >
                    <div className='title-div'>
                      <div className='info_text'>Description</div>
                      {
                        DescriptionInput.length < 500 ? (
                          <div className='help_text'>Limit {500 - DescriptionInput.length}</div>
                        ) : (
                          <div className='help_text blink_text_red' >Limit over {500 - DescriptionInput.length}</div>
                        )
                      }
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <textarea rows={6} className='input_edit' onChange={(e) => setDescriptionInput(e.target.value)} maxLength={500} placeholder='Enter Description'></textarea>
                  </td>
                </tr>

                <tr>
                  <td >
                    <div className='title-div'>
                      <div className='info_text'>Job budget</div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <input
                      onKeyUp={(e) => {
                        e.target.value = e.target.value.replace(/[^0-9]/g, '');
                      }}
                      onChange={(e) => setbudget(e.target.value)}
                      type="text"
                      required
                      maxLength={20}
                      placeholder="Enter budget 0"
                    />
                    <select name="currency" id="currency" onChange={(e) => setcurrency(e.target.value)}>
                      <option value='INR' title='INR'>INR</option>
                      <option value='USD' title='USD'>USD</option>
                    </select>
                    <select
                      name="budgetpackage"
                      id="budgetpackage"
                      onChange={(e) => setbudgetpackage(e.target.value)}
                    >
                      <option value="Daily" title="Daily">Daily</option>
                      <option value="Weekly" title="Weekly">Weekly</option>
                      <option value="Monthly" title="Monthly">Monthly</option>
                      <option value="Quarterly" title="Quarterly">Quarterly</option>
                      <option value="Yearly" title="Yearly">Yearly</option>
                      <option value="One-Time" title="One-Time">One-Time</option>
                    </select>
                  </td>
                </tr>

                <tr>
                  <td >
                    <div className='title-div'>
                      <div className='info_text'>Select Experience</div>

                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <select className='select_edit' onChange={(e) => setexperience(e.target.value)}>
                      <option value="beginner" title='Beginner'>Beginner</option>
                      <option value="intermediate" title='Intermediate'>Intermediate</option>
                      <option value="expert" title='Expert'>Expert</option>
                    </select>
                    {/* <div className='media-div'>
                        <img className='thumbnail-img' src={Thumbnailicon} alt="Thumbnail" />
                        <LiaPhotoVideoSolid className='media-icon' />
                        <div>
      <input type="file" onChange={e => setFile(e.target.files[0])} />
      <button onClick={handleUpload}>Upload</button>
      <p>Upload Progress: {progress}%</p>
      {downloadURL && <p>Download: <a href={downloadURL}>{downloadURL}</a></p>}
    </div>
                      </div> */}
                  </td>
                </tr>
                <tr>
                  <td >
                    <div className='title-div'>
                      <b className='post-header'>Job categories</b>
                      <div className='help_text'> </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td >
                    <div className='title-div'>
                      <div className='info_text'>Skills categories</div>
                      {/* <div className='help_text'>Limit {10 - keywords.length}</div> */}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>

                    <select id='skills_select' style={{ width: '100%' }}
                      onChange={(e) => changeskills(e.target.value)}>
                      <option value="">Select skills</option>
                      {Skillscategories.map((skillscat, index) => (
                        <option
                          key={index}
                          value={skillscat.skillsId}
                          title={skillscat.title}
                        >
                          {skillscat.title}
                        </option>
                      ))}
                    </select>
                  </td>
                </tr>
                <tr>
                  <td >
                    <div className='title-div'>
                      <div className='info_text'>Job categories</div>
                      {/* <div className='help_text'>Limit {10 - keywords.length}</div> */}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <select id='jobcategories_select' style={{ width: '100%' }}>
                      <option>Select job categories</option>
                      {jobcategories.map((jobcat, index) => (
                        <option key={index}
                          value={jobcat.categoryId}
                          title={jobcat.title}
                        >    {jobcat.title}
                        </option>
                      ))}
                    </select>
                  </td>
                </tr>
                <tr>
                  <td >
                    <div className='title-div'>
                      <div className='info_text'>Keywords</div>
                      <div className='help_text'>Limit {10 - keywords.length}</div>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td>
                    <div className="keyword-container">
                      {keywords.map((word, index) => (
                        <div key={index} className="keyword-chip">
                          {word}
                          <span className="remove" onClick={() => removeKeyword(index)}>×</span>
                        </div>
                      ))}
                      <input
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                        onKeyDown={handleKeyDown}
                        className="select_input_edit"
                        maxLength={100}
                        placeholder="Enter keywords"
                      />
                    </div>
                  </td>
                </tr>
                <td >
                  <div className='title-div'>
                    <div className='info_text'>Project Link</div>
                    <div className='help_text'> </div>
                  </div>
                </td>

                <tr>
                  <td>
                    <input list="titles" className="input_edit" maxLength={100} placeholder="Enter Project name (Option)" />
                    <datalist id="titles">
                      <option value="Not Apply" />
                      <option value="Web Developer" />
                      <option value="Designer" />
                      <option value="Content Writer" />
                      <option value="SEO Specialist" />
                    </datalist>
                  </td>
                </tr>
                <tr>
                  <td >
                    <div className='title-div'>
                      <b className='post-header'>Job for location</b>
                      <div className='help_text'> </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td >
                    <div className='title-div'>
                      <div className='info_text'>City</div>
                      <div className='help_text'> </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <input className='input_edit' onChange={(e) => setjobcity(e.target.value)} required maxLength={100} placeholder='Enter city' />
                  </td>
                </tr>
                <tr></tr>
                <tr>
                  <td >
                    <div className='title-div'>
                      <div className='info_text'>State</div>
                      <div className='help_text'> </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <input className='input_edit' onChange={(e) => setjobstate(e.target.value)} required maxLength={100} placeholder='Enter State' />
                  </td>
                </tr>
                <tr>
                  <td >
                    <div className='title-div'>
                      <div className='info_text'>Country</div>
                      <div className='help_text'> </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <PhoneCodeList
                      onChange={handlecountryChange}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
            <br />  <br />
          </div>

          <div className="post_updates">
            <div className='post-submit-div'>
              <a >Post Visibility</a>
              <table width="100%">
                <tbody>

                  <tr>
                    <td ><MdOutlineVisibility className='icon_img' /></td>
                    <td >

                      <select
                        className="select_edit"
                        value={visibility}
                        onChange={(e) => setvisibility(e.target.value === 'true')}
                      >
                        <option value="true">Public</option>
                        <option value="false">Private</option>
                      </select>
                    </td>
                  </tr>
                </tbody>
              </table>
              <br />
              <div onClick={editor_Publish_btn} className='button-ui' style={{ width: '93%' }}>
                {loading ? <Loadingimg /> : <MdPublic className='icon' />} Publish
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
      </>
  );
}
